import {CatalogConfig} from '../types'

// Pilot catalog: Experience Beneficiaries (institutions/NGOs an experience can benefit).
// Backend: experiences.ExperienceBeneficiary — full CRUD ModelViewSet at
// /api/v1/experiences/beneficiaries/, admin-gated writes, `active` soft-delete already
// present, search on name/description. Serializer fields: id, name, description, website,
// active. Referenced by Experience.beneficiaries (M2M); deactivating a value keeps it on
// existing experiences (read serializer does not filter by active) — it only stops appearing
// as selectable, so read paths do not break.
export const experienceBeneficiariesConfig: CatalogConfig = {
  slug: 'experience-beneficiaries',
  endpoint: '/experiences/beneficiaries/',
  titleId: 'CATALOG.EXPERIENCE_BENEFICIARIES.TITLE',
  singularId: 'CATALOG.EXPERIENCE_BENEFICIARIES.SINGULAR',
  primaryField: 'name',
  softDelete: {field: 'active', activeValue: true},
  // Server-side pagination + status. statusParam 'active' pushes the active/inactive dropdown to
  // the backend (?active=true|false; 'All' omits it) so it filters the whole set, not one page.
  // Requires the backend `active` filter (nobilis-social ExperienceBeneficiaryFilter).
  serverSide: {searchParam: 'search', statusParam: 'active'},
  fields: [
    {
      name: 'name',
      labelId: 'CATALOG.FIELD.NAME',
      type: 'text',
      required: true,
      maxLength: 255,
      showInTable: true,
      searchable: true,
    },
    {
      name: 'description',
      labelId: 'CATALOG.FIELD.DESCRIPTION',
      type: 'textarea',
      showInTable: true,
      searchable: true,
    },
    {
      name: 'website',
      labelId: 'CATALOG.FIELD.WEBSITE',
      type: 'url',
      showInTable: true,
    },
  ],
}
